import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import AscModal from "../Elements/Modal/Modal";
import {EditSerialCount, EditDescription} from "../Elements/AscElements/DeviceElements";

export default class DeviceInsertModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.DeviceInfo}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <EditSerialCount
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange={this.props.onTextChange}
                            isValidSerialCount={this.props.isValidSerialCount}
                        />
                        <EditDescription
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange={this.props.onTextChange}
                        />
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

DeviceInsertModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
    isValidSerialCount: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
